























































import { CampaignReportData } from "@/models/CampaignReport";
import Site from "@/models/site";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ApexCharts from "vue-apexcharts";
import moment from "moment";

@Component({ components: { ApexCharts } })
export default class ClientCampaignReportSummary extends Vue {
  @Prop() sites!: Site[];
  @Prop() inputData!: CampaignReportData;

  dailyClicks: { name: string; type: string; data: number[] }[] = [];
  dailyPrints: { name: string; type: string; data: number[] }[] = [];

  created(): void {
    this.dailyClicks = this.getDailyData("click");
    this.dailyPrints = this.getDailyData("print");
  }

  get totalClicks(): number {
    return this.inputData.data.reduce((p, c) => p + c.clicks, 0);
  }

  get totalPrints(): number {
    return this.inputData.data.reduce((p, c) => p + c.prints, 0);
  }

  get ctr(): number {
    return (this.totalClicks / this.totalPrints) * 100;
  }

  getOptions(type: string) {
    return {
      title: {
        text: this.$t(`reports.campaign.${type}`).toString(),
      },
      xaxis: {
        title: { text: this.$t("reports.campaign.dates") },
        min: moment(this.inputData.meta.report.start).toDate().getTime(),
        type: "datetime",
        tickAmount: 6,
      },
      yaxis: [
        {
          title: {
            text: this.$t(`reports.campaign.${type}_amount`).toString(),
          },
        },
      ],
      dataLabels: {
        enabled: false,
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
    };
  }

  getDailyData(metric: string): { name: string; type: string; data: any }[] {
    const dates = this.getCategories();
    const data: { date: number; value: number; formatedDate: string }[] = [];
    dates.forEach((d) => {
      const dt = moment(d);
      data.push({
        date: d.getTime(),
        formatedDate: dt.format("YYYY-MM-DD"),
        value: 0,
      });
    });

    this.inputData.dailyData.forEach((d) => {
      const date = moment(`${d.year}-${d.month}-${d.day}`).format("YYYY-MM-DD");

      const index = data.findIndex((dt) => {
        return dt.formatedDate === date;
      });

      if (metric === "click") {
        data[index].value += d.clicks;
      } else {
        data[index].value += d.prints;
      }
    });

    return [
      {
        name: this.$t(`reports.campaign.${metric}s`).toString(),
        type: "column",
        data: data.map((d) => [d.date, d.value]),
      },
    ];
  }

  getCategories(): Date[] {
    const start = moment(this.inputData.meta.report.start);
    const end = moment(this.inputData.meta.report.end);
    const days = end.diff(start, "days");
    const categories = [];

    categories.push(start.toDate());
    for (let i = 0; i < days; i++) {
      categories.push(start.add(1, "d").toDate());
    }

    return categories;
  }
}
